import { render, staticRenderFns } from "./productDetailInventory.vue?vue&type=template&id=39b122d3&scoped=true"
import script from "./productDetailInventory.vue?vue&type=script&lang=js"
export * from "./productDetailInventory.vue?vue&type=script&lang=js"
import style0 from "./productDetailInventory.vue?vue&type=style&index=0&id=39b122d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b122d3",
  null
  
)

export default component.exports